import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

const FormModal = (props) => {
  const {
    className,
    modal,
    setModal,
    children
  } = props;

  const toggle = () => setModal(!modal);
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalBody>
            {children}
        </ModalBody>
      </Modal>
    </div>
  );
}

export default FormModal;